import axios from "axios";
import Swal from "sweetalert2";

export const getZones = async (lang ,city_id ) => {
  try {
    const brear = localStorage.getItem("token");
   
    const { data } = await axios.get("/v1/admin/zones", {
      
        params:{
city_id 
        },
      
      headers: {
        Authorization: "Bearer " + `${brear}`,
             
        "Accept-Language": lang,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};


export const showZones = async (id, selectedLangCode) => {
  try {
    const brear = localStorage.getItem("token");
    let lang = localStorage.getItem("i18nextLng");
    if (selectedLangCode) {
      lang = selectedLangCode;
    }
    const { data } = await axios.get(`/v1/admin/zones/${id}`, {
      params: {
        lang: lang,
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,

        "Accept-Language": lang,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const postZones = async (postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post("/v1/admin/zones", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};



export const updateZones = async (postData,id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/zones/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteZones = async (id, lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/zones/${id}`, {
        headers:{
                  Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
        }

      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};
